import React from "react";
import { Link } from "react-router-dom";
import "./statusPages.css";

const SuccessPage = () => {
  return (
    <div className="status-container success-bg">
      <div className="status-card">
        <div className="status-icon success-icon">✓</div>

        <h1>Order Placed Successfully!</h1>

        <p>
          Thank you for your order. Your purchase has been completed
          successfully. You have been emailed with your order number and other
          important details.
        </p>

        <p>
          If you need any assistance, please contact us at{" "}
          <strong>info@well-shape.store</strong>.
        </p>

        <p>Thanks for shopping with us!</p>

        <div className="status-buttons">
          <Link to="/" className="btn btn-success">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
